<template>
  <div class="w3-main main-container">

    <page-header />

    <div class="w3-container about-container">
      <h1 class="w3-xxxlarge"><b>{{ title }}</b></h1>

      <hr class="w3-round">

      <p v-html="item.text[locale]"></p>

      <gallery
        :images="galleryImages.map(image => `/static/images/agc/items/${item._id}/${image}`)"
        :index="index"
        @close="index = null"
        :options="{ displayClass: 'blueimp-gallery-display-fix' }"
      />

      <router-link to="/agc">
        <button
          class="w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
        >
          {{ $t('Back to AGC') }}
        </button>
      </router-link>

      <div class="gallery-container">
        <div
          class="gallery-thumbnail"
          v-for="(image, imageIndex) in galleryImages"
          :style="{ 'background-image': `url(/static/images/agc/items/${item._id}/${image})` }"
          @click="index = imageIndex"
        ></div>
      </div>

      <router-link to="/agc">
        <button
          class="w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
        >
          {{ $t('Back to AGC') }}
        </button>
      </router-link>
    </div>
  </div>
</template>

<i18n>
  {
    "de": {
      "Back to AGC": "Vissza az üvegekhez"
    },
    "en": {
      "Back to AGC": "Vissza az üvegekhez"
    },
    "hu": {
      "Back to AGC": "Vissza az üvegekhez"
    }
  }
</i18n>

<script>
  import Gallery from 'vue-gallery';
  import PageHeader from '@/components/PageHeader';
  import items from 'static/data/agc.json';

  const itemGaleries = {};

  require
    .context('static/images/agc/items/', true, /\.(jpg)$/)
    .keys()
    .map(categories => categories.split('/'))
    .forEach((categoryElem) => {
      const categoryName = categoryElem[1];
      const albumImage = categoryElem[3];
      let albumName;
      let imageName;

      if (albumImage) {
        albumName = categoryElem[2];
      } else {
        imageName = categoryElem[2];
      }

      if (albumImage) {
        itemGaleries[categoryName] = itemGaleries[categoryName] || {};
        itemGaleries[categoryName][albumName] = itemGaleries[categoryName][albumName] || [];
        itemGaleries[categoryName][albumName].push(albumImage);
      } else {
        itemGaleries[categoryName] = itemGaleries[categoryName] || [];
        itemGaleries[categoryName].push(imageName);
      }
    });

  export default {
    name: 'AgcItem',
    data() {
      return {
        items,
        itemGaleries,
        index: null,
      };
    },
    created() {
      if (!this.item) {
        this.$router.replace('/agc');
        return;
      }

      document.title = `${this.item.title.hu.replace('<br>', ' ')} | BeCreative`;
    },
    mounted() {
      scrollTo(0, 0);
    },
    computed: {
      item() {
        const itemId = this.$route.params._id;

        return this.items.find(item => item._id === itemId);
      },
      galleryImages() {
        const galleryImages = this.itemGaleries[this.item._id];

        if (!galleryImages) {
          return [];
        }

        if (!Array.isArray(galleryImages)) {
          const images = [];

          Object.keys(galleryImages)
            .forEach((key) => {
              galleryImages[key].forEach((image) => {
                images.push(`${key}/${image}`);
              });
            });

          return images;
        }

        return galleryImages;
      },
      locale() {
        return this.$store.state.i18n.locale;
      },
      title() {
        return this.item.title[this.locale].replace('<br>', ' ');
      },
    },
    components: {
      Gallery,
      PageHeader,
    },
  };
</script>


<style scoped>
  a {
    text-decoration: none;
  }

  button {
    background-color: #eb2e4a !important;
  }

  hr {
    width: 50px;
    border: 5px solid;
    color: #eb2e4a !important;
    margin-top: 0px;
  }

  .about-container {
    margin-top: 75px;
    max-width: 1000px;
  }

  .gallery-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 16px;
  }

  .gallery-thumbnail {
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: cover;
    width: 200px;
    height: 200px;
    margin: 3px;
    cursor: pointer;
  }

  @media (max-width: 460px) {
    .gallery-thumbnail {
      width: 100vw;
      height: 100vw;
      margin: 1px -16px 1px -16px;
    }
  }
</style>



// WEBPACK FOOTER //
// AgcItem.vue?02f32652